import { cn } from '@nucleus-commerce/ui/lib/utils';

import { socialNetwork, type SocialNetworkId } from '../networks';

const SIZES = {
  sm: { box: 'size-8 rounded-md', icon: 'size-4' },
  md: { box: 'size-10 rounded-lg', icon: 'size-5' },
};

/** The network's mark: its glyph on a tile in the brand colour. Decorative; the name sits beside it. */
export function NetworkTile({
  network,
  size = 'md',
  className,
}: {
  network: SocialNetworkId;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  const { icon: Icon, tile } = socialNetwork(network);
  return (
    <span
      aria-hidden
      className={cn('flex shrink-0 items-center justify-center', SIZES[size].box, tile, className)}
    >
      <Icon className={SIZES[size].icon} />
    </span>
  );
}
